module.exports = __webpack_public_path__ + "img/FanYong.4546ed95.svg";